// A form's words, kept on the phone while it is being filled in. iOS unloads the app when the
// camera opens or the phone is pocketed, then reloads it from scratch; without this, everything
// typed is gone. Each screen keeps one entry per job and day, writes it as the person types,
// restores it on return, and clears it when the record is filed.
import { useEffect, useRef } from 'react';

const PREFIX = 'tv.draft.';
export interface LocalDraft<T> { at: number; v: T }

export function readLocalDraft<T>(key: string | null): T | null {
  if (!key) return null;
  try { const raw = localStorage.getItem(PREFIX + key); if (!raw) return null; const d = JSON.parse(raw) as LocalDraft<T>; return Date.now() - d.at < 36 * 3600_000 ? d.v : null; } catch { return null; }
}
export function writeLocalDraft<T>(key: string | null, v: T) {
  if (!key) return;
  try { localStorage.setItem(PREFIX + key, JSON.stringify({ at: Date.now(), v } satisfies LocalDraft<T>)); } catch { /* storage full or private mode */ }
}
export function clearLocalDraft(key: string | null) {
  if (!key) return;
  try { localStorage.removeItem(PREFIX + key); } catch { /* fine */ }
}

/** Write `value` to the phone whenever it changes (debounced), under `key`. */
export function useLocalDraft<T>(key: string | null, value: T, enabled = true) {
  const t = useRef<number | null>(null);
  const json = JSON.stringify(value);
  useEffect(() => {
    if (!key || !enabled) return;
    if (t.current) clearTimeout(t.current);
    t.current = window.setTimeout(() => writeLocalDraft(key, JSON.parse(json) as T), 250);
    return () => { if (t.current) clearTimeout(t.current); };
  }, [key, json, enabled]);
}
